module.exports = __webpack_public_path__ + "img/319-e603a8.png";